import React from "react";
import Icon from "../../../components/AppIcon";

const MissionVisionSection = () => {
  const values = [
    {
      icon: "Target",
      title: "Excellence",
      description:
        "Commitment to the highest standards in technical education and skill development",
      color: "bg-yellow-800",
    },
    {
      icon: "Lightbulb",
      title: "Innovation and Creativity",
      description:
        "Embracing cutting-edge technologies and modern teaching methodologies",
      color: "bg-yellow-800",
    },
    {
      icon: "Heart",
      title: "Integrity",
      description:
        "Maintaining transparency, honesty, and ethical practices in all endeavors",
      color: "bg-yellow-800",
    },
    {
      icon: "Users",
      title: "Teamwork and Professionalism",
      description:
        "Building strong partnerships with industry and fostering teamwork",
      color: "bg-yellow-800",
    },
    {
      icon: "Briefcase",
      title: "Good Governance",
      description:
        "Building strong partnerships with industry and fostering teamwork",
      color: "bg-yellow-800",
    },
    {
      icon: "Users",
      title: "Customer Focus",
      description:
        "Building strong partnerships with industry and fostering teamwork",
      color: "bg-yellow-500",
    },
    {
      icon: "Handshake",
      title: "Unity in Diversity",
      description:
        "Building strong partnerships with industry and fostering teamwork",
      color: "bg-yellow-800",
    },
  ];

  return (
    <section className="py-20 bg-blue-100">
      <div className="container mx-auto px-6 lg:px-8">
        {/* Mission & Vision */}
        <div className="grid lg:grid-cols-2 gap-16 mb-20">
          {/* Mission */}
          <div className="bg-card rounded-2xl p-8 shadow-card-lg border border-border">
            <div className="flex items-center space-x-4 mb-6">
              <div className="w-16 h-16 bg-primary/10 rounded-xl flex items-center justify-center">
                <Icon name="Compass" size={32} color="var(--color-primary)" />
              </div>
              <h2 className="text-3xl font-bold text-foreground">
                Our Mission
              </h2>
            </div>
            <p className="text-lg text-muted-foreground leading-relaxed mb-6">
              To provide holistic Technical and Vocational Education & Training
              programmes for self-reliance, community development and global
              competence
            </p>
            <div className="flex items-center space-x-2 text-primary font-medium">
              <Icon name="ArrowRight" size={20} />
              <span>Empowering the Future</span>
            </div>
          </div>

          {/* Vision */}
          <div className="bg-card rounded-2xl p-8 shadow-card-lg border border-border">
            <div className="flex items-center space-x-4 mb-6">
              <div className="w-16 h-16 bg-accent/10 rounded-xl flex items-center justify-center">
                <Icon name="Eye" size={32} color="var(--color-accent)" />
              </div>
              <h2 className="text-3xl font-bold text-foreground">Our Vision</h2>
            </div>
            <p className="text-lg text-muted-foreground leading-relaxed mb-6">
              To be an outstanding institute in Technical and Vocational
              Education & Training (TVET) and innovation{" "}
            </p>
            <div className="flex items-center space-x-2 text-accent font-medium">
              <Icon name="ArrowRight" size={20} />
              <span>Leading Technical Excellence</span>
            </div>
          </div>
        </div>

        {/* Core Values */}
        <div className="text-center bg-blue-700 mb-12">
          <h2 className="text-4xl font-bold text-yellow-600 mb-4">
            Our Core Values
          </h2>
          <p className="text-xl text-white max-w-3xl mx-auto">
            The principles that guide our commitment to excellence and shape our
            educational philosophy
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {values?.map((value, index) => (
            <div key={index} className="text-center group">
              <div className="w-20 h-20 bg-yellow-600 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <Icon name={value?.icon} size={32} color="white" />
              </div>
              <h3 className="text-xl font-bold text-black mb-3">
                {value?.title}
              </h3>
              <p className="text-black leading-relaxed">
                {value?.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MissionVisionSection;
